module.exports = __webpack_public_path__ + "static/media/close-black.f19fb87a.svg";